import React, { useEffect, useState } from "react";
import "./SecureContent.css"; // Add styles to block screenshots

const SecureContent = () => {
  const [isScreenshotAttempted, setScreenshotAttempted] = useState(false);

  useEffect(() => {
    // Disable right-click
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable DevTools, Copy, Inspect, PrintScreen
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" || // Disable F12
        e.key === "PrintScreen" || // Disable PrintScreen
        (e.ctrlKey &&
          (e.key === "c" ||
            e.key === "C" ||
            e.key === "u" ||
            e.key === "U" ||
            e.key === "s" ||
            e.key === "S" ||
            e.key === "p" ||
            e.key === "P" ||
            e.key === "Shift")) ||
        (e.metaKey &&
          (e.key === "c" ||
            e.key === "C" ||
            e.key === "u" ||
            e.key === "U" ||
            e.key === "s" ||
            e.key === "S" ||
            e.key === "p" ||
            e.key === "P" ||
            e.key === "Shift")) ||
        (e.ctrlKey && e.shiftKey && e.key === "I") || // Disable Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.key === "C")
      ) {
        e.preventDefault();
        setScreenshotAttempted(true); // Show blocker overlay
        setTimeout(() => setScreenshotAttempted(false), 2000); // Hide overlay after 3 sec
      }
    };

    // Disable dragging of images & text selection dragging
    const disableDrag = () => {
      document
        .querySelectorAll("img, p, h1, h2, h3, h4, h5, h6, span, div")
        .forEach((el) => {
          el.setAttribute("draggable", "false");
          el.addEventListener("dragstart", (e) => e.preventDefault());
        });
    };

    // Disable Developer Tools (Right-click + Inspect)
    const handleDevToolsOpen = (event) => {
      event.preventDefault();
    };

    const secureIframe = () => {
      const iframe = document.getElementById("secureIframe");
      if (iframe && iframe.contentWindow) {
        try {
          const iframeDoc = iframe.contentWindow.document;
          iframeDoc.addEventListener("contextmenu", (e) => e.preventDefault());
          iframeDoc.addEventListener("keydown", handleKeyDown);
          disableDrag(); // Disable dragging inside the iframe
        } catch (err) {
          console.warn(
            "Cannot access iframe content due to CORS restrictions."
          );
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleDevToolsOpen);
    disableDrag(); // Apply the drag prevention
    setTimeout(secureIframe, 1000); // Ensure iframe content is loaded
    return () => {
      document.removeEventListener("contextmenu", handleDevToolsOpen);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="secure-content">
      {isScreenshotAttempted && (
        <div className="screenshot-blocker">
          <h4 className="text-white ct_fs_24" style={{ opacity: "0.5" }}>
            Copy Restricted
          </h4>
          <p className="text-white" style={{ opacity: "0.5" }}>
            You are unable to copy content from the website due to privacy
            policy restrictions.
          </p>
        </div>
      )}
    </div>
  );
};

export default SecureContent;
